import React from "react";
import styled from "styled-components";

import {BubbleWrapper, MessageWrapper} from "../../../global/style";
import {connect} from "react-redux";

const ImageBubbleWrapper = styled(BubbleWrapper)`
  display: flex;
  justify-content: flex-end;
  max-width: 100%;

  @media screen and (max-width: ${(prop) => prop.theme.screenSizes.breakSmall}) {
   margin-top: 16px;
  }
`;

const Bubble = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 78px;
  height: 78px;
  background: ${(props) => props.theme.themeColors[props.theme.activeTheme].quicklinkImageBackgroundColor};
  box-sizing: border-box;
  border-radius: 8px;
  box-shadow: 0px 0px 6px 0px rgba(180, 180, 180, 0.25);
  border: 1px solid ${(props) => props.theme.themeColors[props.theme.activeTheme].main};

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
    width: 120px;
    height: 120px;
  }
`;

const StyledImage = styled.img`
  height: 43px;

 @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
    height: 62px;
  }
`;


const ImageText = styled.div`
  text-transform: capitalize;
  font-size: 11px;
  font-family: Poppins;
  color: ${(props) => props.theme.themeColors[props.theme.activeTheme].quicklinkImageText};
  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
    font-size: 17px;
  }
`

const MultibotWrapper = styled.div`
    display: flex;
    font-family: "Dm sans";
    font-weight: 700;
    text-align: left;
    justify-content: flex-start;
    border: 2px solid rgb(240, 240, 240);
    width: 250px;
    border-radius: 8px;
    height: 100px;
    padding: 0 12px 0 6px !important;
    align-items: center;
    margin-left: auto;
    margin-top: 12px;

    img {
      width: 64px;
      height: 64px;
      margin: 0px 7px 0px 0px;
      border-radius: 50%;
      border: 4px solid rgb(66, 172, 205);
      box-sizing: border-box;
      margin: 0px 7px;
  }

  .property-name {
    font-size: 14px;
    line-height: 19px;
    font-weight: 700;
  }

  .property-info {
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
  }

`

const MultibotInfo = styled.div`
`

function Image({data, activeTheme}) {
  const isStudio = data.image && data.image.startsWith("0-");
  const imageBasePath = `/images/${activeTheme === "dark" ? "dark-mode" : "light-mode"}/quicklinks/`;
  let image;
  let imageText;
  const moreThanOneBedroom = data.image.match(/\d+/) && parseInt(data.image.match(/\d+/)[0]) > 1;
    if (data.image.includes("0")) {
       image = "0-bed.svg"
       imageText = isStudio ? "studio" : "bedroom";
       if(data.image.includes("es")){
        imageText = isStudio ? "estudio" : "habitacion";
       }
    } else {
        if(data.image.includes("es")){
          image= data.image.replace("-es", "");
          imageText = isStudio ? "estudio" : "habitacion";
          if (moreThanOneBedroom) {
            imageText = "habitaciones";
          }
        }
        else{
          imageText = isStudio ? "studio" : "bedroom";
          image= data.image;
          if (moreThanOneBedroom) {
            imageText = "bedrooms";
          }
        }
      }     
  let isMultibot = data.value.includes("MultibotSelect") || data.value.includes("NearbyPropertiesSelect");
 
  let imageFullPath = `${imageBasePath}${image}`;

 
  if(data.image.includes("http")) {
     imageFullPath = data.image;
  }

  return (
    <MessageWrapper className="ImageMessageWrapper">

    {  isMultibot ? (  
        <MultibotWrapper>
          <div width="78">
          <img src={imageFullPath} alt="property"/>
          </div>
          <MultibotInfo>
            <div className="property-name">
              {data.text}
              </div>
            <div className="property-info">
              {data.address}
              </div>
          </MultibotInfo>
          </MultibotWrapper>
      ) : (
      <ImageBubbleWrapper className="ImageBubbleWrapper">
        <Bubble className="Bubble user-messages" title="selected-image" data={data}>
             <StyledImage
              alt={data.value + " bedrooms image"}
              src={imageFullPath}
            />
          <ImageText>{imageText}</ImageText>
        </Bubble>
      </ImageBubbleWrapper>
      ) 
      }
    </MessageWrapper>
  );
}


const mapStateToProps = (state) => ({
  activeTheme: state.settings.activeTheme,
});

export default connect(mapStateToProps, null)(Image);
